import { FC } from "react";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

const IconWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "icon-wrapper",
})`
  html[dir="rtl"] &.flip-icon {
    transform: scaleX(-1);
  }
`;

interface IIconRtl {
  name: string;
  onClick: () => void;
  noFlip?: boolean;
}

export const IconRtl: FC<IIconRtl> = ({ name, onClick, noFlip }) => {
  return (
    <IconWrapper onClick={onClick} className={noFlip ? "" : "flip-icon"}>
      <i className={`icon icon-${name}`} title={name} />
    </IconWrapper>
  );
};
